import { connect } from 'react-redux';
import CreatePoliticaCobranca from './createPoliticaCobranca';

export default connect()(CreatePoliticaCobranca);
